import {clsx} from 'clsx';

export const flex = 'flex';
export const centerContent = clsx(flex, 'flex align-items-center justify-content-center');
export const centerOfScreen = clsx(centerContent, 'h-screen');
